import { api } from './api';

export interface TerritoryOwnership {
    county_fips: string;
    team_id: number;
    league_id: string;
    county_name: string;
    state_name: string;
    centroid_latitude: number;
    centroid_longitude: number;
    team_name: string;
    primary_color: string;
    secondary_color: string | null;
    map_color: string | null;
    espn_team_id?: number | null;
    logo_url?: string | null;
    short_name?: string | null;
}

export interface OwnershipResponse {
    success: boolean;
    ownership: TerritoryOwnership[];
    date?: string | null;
}

export interface AvailableDate {
    snapshot_date: string;
    snapshot_timestamp: string;
    games_processed_count: number;
    is_preseason?: boolean;
}

export interface AvailableDatesResponse {
    success: boolean;
    dates: AvailableDate[];
}

export const ownershipService = {
    getOwnershipByLeague: async (leagueId: string, date?: string, season?: number): Promise<OwnershipResponse> => {
        const params = new URLSearchParams();
        if (date) params.append('date', date);
        if (season != null) params.append('season', String(season));
        const qs = params.toString();
        const url = qs
            ? `/ownership/${leagueId}/ownership?${qs}`
            : `/ownership/${leagueId}/ownership`;
        const response = await api.get<OwnershipResponse>(url);
        if (response.success && response.data) {
            return response.data as OwnershipResponse;
        }
        throw new Error(response.error || 'Failed to fetch territory ownership');
    },

    getAvailableDates: async (leagueId: string, season?: number): Promise<AvailableDate[]> => {
        const url = season != null
            ? `/ownership/${leagueId}/ownership/dates?season=${season}`
            : `/ownership/${leagueId}/ownership/dates`;
        const response = await api.get<AvailableDatesResponse>(url);
        if (response.success && response.data) {
            return response.data.dates || [];
        }
        return [];
    },
};

